<template>
  <div class="con-box">
    <div class="title">
      <span><img src="./images/company-logo.png"
             alt=""
             srcset="" /></span>
      <span @click="back">返回首页</span>
    </div>
    <div class="tabs">
      <div class="item-list"
           :class="{ active: currentType == 1 }"
           @click="currentType = 1">
        <img src="./images/primary.png"
             alt=""
             srcset="" />
        <span class="item-span">小学学习APP
          <span class="active-span"></span>
        </span>
      </div>
      <div class="item-list"
           :class="{ active: currentType == 2 }"
           @click="currentType = 2">
        <img src="./images/senior.png"
             alt=""
             srcset="" />
        <span class="item-span">中学学习APP
          <span class="active-span"></span>
        </span>
      </div>
      <div class="item-list"
           :class="{ active: currentType == 3 }"
           @click="currentType = 3">
        <img src="./images/qujiao.png"
             alt=""
             srcset="" />
        <span class="item-span">趣教APP<span class="active-span"></span></span>
      </div>
    </div>
    <div class="content">
      <div class="ctrl">
        <div>
          <img src="./images/next.png"
               class="next"
               @click="next"
               alt=""
               srcset="" />
          <img src="./images/pre.png"
               class="pre"
               @click="pre"
               alt=""
               srcset="" />
        </div>
      </div>

      <div class="wapper">
        <div class="flex-div content-div">
          <div class="flex-left">
            <div class="flex-left-content"
                 v-if="currentType == 1">
              <div class="content-title">小学学习APP</div>
              <div class="content-subtitle">小学学习智能教辅平台</div>
              <div class="img-wapper"
                   ref="primaryScroll">
                <div v-for="(item, index) in xx"
                     :key="index"
                     class="img-wapper-div"
                     @mouseover="enter(index, $event)"
                     @mouseleave="out">
                  <img :src="require('./images/logo-' + (index + 1) + '.png')"
                       alt=""
                       srcset=""
                       class="primary-logo"
                       :class="{big : currentIndex == index}"
                       :ref="'img' + index" />
                  <div class="code-logo"
                       :style="boxStyle"
                       v-if="currentIndex == index">

                    <div class="qrcode">
                      <img :src="require('./images/primary/code-' + (currentIndex + 1) +'.png')"
                           alt="">
                      <h1>{{xx[index].name}}</h1>
                      <p>微信扫码下载</p>
                    </div>

                    <div class="disc">
                      <h2 v-if="xx[index].business_id!==3 && xx[index].business_id!==15">三大主科，30项功能特权</h2>
                      <ul v-if="xx[index].business_id===3 || xx[index].business_id===15">
                        <li>
                          <h3>英语</h3>
                          <p>19大功能特权，助力英语课后高效辅导</p>
                          <p>课本点读、练口语、考试测评、早读课程、课前预习、课后巩固、阅读训练、语法训练、听力训练、每日英语、老师作业、丢分题、精选收藏、听力、欧美课程、学习工具、乐配音、乐配音测评、词典</p>
                        </li>
                      </ul>

                      <ul v-else>
                        <li>
                          <h3>英语</h3>
                          <p>19大功能特权，助力英语课后高效辅导</p>
                          <p>课本点读、练口语、考试测评、早读课程、课前预习、课后巩固、阅读训练、语法训练、听力训练、每日英语、老师作业、丢分题、精选收藏、听力、欧美课程、学习工具、乐配音、乐配音测评、词典</p>
                        </li>
                        <li>
                          <h3>语文</h3>
                          <p>6大功能特权，助力语文课后高效辅导</p>
                          <p>字词闯关、作文宝典、课内同步学、老师作业、课文跟读、名家朗读</p>
                        </li>
                        <li>
                          <h3>数学</h3>
                          <p>5大功能特权，助力数学课后高效辅导</p>
                          <p>课内知识点视频讲解、巩固练习、精选收藏、老师作业、丢分题</p>
                        </li>
                      </ul>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-left-content"
                 v-if="currentType == 2">
              <div class="content-title">中学学习APP</div>
              <div class="content-subtitle">中学学习智能教辅平台</div>
              <div class="img-wapper"
                   ref="primaryScroll">
                <div v-for="(item, index) in 16"
                     :key="index"
                     class="img-wapper-div"
                     @mouseover="enter(index, $event)"
                     @mouseleave="out">
                  <img :src="require('./images/senior-logo-' + (index + 1) + '.png')"
                       alt=""
                       srcset=""
                       class="primary-logo"
                       :class="{big : currentIndex == index}"
                       :ref="'img' + index" />
                  <div class="code-logo"
                       :style="boxStyle"
                       v-if="currentIndex == index">

                    <div class="qrcode">
                      <img :src="require('./images/senior/code-' + (currentIndex + 1) +'.png')"
                           alt="">
                      <h1>{{zx[index].name}}</h1>
                      <p>微信扫码下载</p>
                    </div>

                    <div class="disc">
                      <h2 class="zx">{{zx[index].name}}，是一款中学在线智能辅导学习产品，课程涵盖初中，高中学段，包括语文、数学、英语、物理、化学、生物、历史、地理、政治等学科内容，致力于让每个学生学习更高效。要提分，用{{zx[index].name}}！</h2>

                      <ul>
                        <li>
                          <h3>同步数字教辅</h3>
                          <p>紧扣教材，结合考试，归纳常考易错知识点，练讲互动，衔接中考，帮助你高效复习。</p>
                        </li>
                        <li>
                          <h3>学科百宝箱</h3>
                          <p>学科知识的百科全书，课堂内外的查询工具，学法、技法、用法、考法的金钥匙。</p>
                        </li>
                        <li>
                          <h3>重难点讲解</h3>
                          <p>关键性知识点考点精讲巧讲，化烦琐为简单 ，采用新手段新方法强化点拨 ，提升解题能力。</p>
                        </li>
                        <li>
                          <h3>笔记本</h3>
                          <p>构建你专属的云学习笔记，包含作业本、错题本、单词本、字词本多种形态，帮你培养好的记录习惯。 </p>
                        </li>
                      </ul>

                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="flex-left-content qujiao-content"
                 v-if="currentType == 3">
              <div class="content-title">趣教APP</div>
              <div class="content-subtitle">让教学更有趣！</div>
              <div class="img-wapper-div"
                   @mouseover="enter(0)"
                   @mouseleave="out"
                   ref="primaryScroll">
                <img :src="require('./images/logo-qujiao.png')"
                     class="qujiao"
                     ref="img0" />
                <div class="code-logo"
                     :class="{big : currentIndex == 0}"
                     :style="boxStyle"
                     v-if="currentIndex == 0">

                  <div class="qrcode">
                    <img :src="require('./images/code-qujiao.png')"
                         alt="">
                    <h1>{{qj.name}}</h1>
                    <p>微信扫码下载</p>
                  </div>

                  <div class="disc">
                    <h2>趣教—让教学更有趣</h2>

                    <ul>
                      <li>
                        <p>趣教，是一款专为小学英语老师设计的教学辅助软件，帮助老师提升课堂互动效果、在线布置作业、管理班级以及实时掌控学生学习数据。</p>
                      </li>
                      <li>
                        <h3>经典功能</h3>
                        <p>1. 课堂遥控器，提升课堂互动效果；</p>
                        <p>2. 布置个性化作业，提升每一个学生学习效果；</p>
                        <p>3. 根据学习情况给予不同奖励，提升学生学习动力；</p>
                        <p>4. 布置趣味作业，提升学生学习兴趣；</p>
                        <p>5. 实时掌握学生学习状况，及时调整教学重点；</p>
                        <p>6. 学生在线做练习，高效自动批改，让老师把时间花在更有价值的地方。</p>
                      </li>
                    </ul>

                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="flex-right">
            <img src="./images/primary-bg.png"
                 alt=""
                 srcset=""
                 v-if="currentType == 1" />
            <img src="./images/senior-bg.png"
                 alt=""
                 srcset=""
                 v-if="currentType == 2" />
            <img src="./images/qujiao-bg.png"
                 alt=""
                 srcset=""
                 v-if="currentType == 3" />
          </div>

        </div>
      </div>

    </div>
    <div class="footer">
      <p class="copyright">Copyright © 2015-2024 智慧流版权所有</p>
      <div class="beian">
        <span class="msg"> <span>京ICP备15042556号-1</span></span>
        <a target="_blank"
           href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802030160"
           style="text-decoration: none; height: 20px; line-height: 20px">
          <img src="./images/beian.png" />
          <p style="
              height: 20px;
              line-height: 20px;
              margin: 0px 0px 0px 5px;
              color: #939393;
            ">
            京公网安备 11010802030160号
          </p>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { xx } from '../../assets/js/xx'
import { zx } from '../../assets/js/zx'
import { qj } from '../../assets/js/qj'
export default {
  name: 'discoveryPage',

  data() {
    return {
      currentType: 1, // 1为小学，2为中学，3为趣教
      currentIndex: -55,
      boxStyle: {},
      xx: xx,
      zx: zx,
      qj: qj,
      bodyHeight: document.body.clientHeight
    }
  },
  methods: {
    back() {
      location.href = './index.html'
    },
    enter(index) {
      let sTop = 0
      sTop = this.$refs['primaryScroll'] ? this.$refs['primaryScroll'].scrollTop : 0
      const scrollT = document.documentElement.scrollTop
      const offsetT = this.$refs['primaryScroll'] ? this.$refs['primaryScroll'].offsetTop - scrollT : 0
      const offsetL = this.$refs['primaryScroll'] ? this.$refs['primaryScroll'].offsetLeft : 0
      this.currentIndex = index
      let dom = this.$refs['img' + index]
      if (dom instanceof Array) {
        const oTop = dom[0].offsetTop - sTop
        const left = dom[0].offsetLeft + offsetL
        if (offsetT + oTop + 78 + 350 > this.bodyHeight) {
          this.boxStyle = {
            top: offsetT + oTop - 350 < 0 ? 0 : offsetT + oTop - 350 + 'px',
            left: left - 46 + 'px'
          }
        } else {
          this.boxStyle = {
            top: offsetT + oTop + 78 + 'px',
            left: left - 46 + 'px'
          }
        }
      } else {
        const top = dom.offsetTop
        const left = dom.offsetLeft
        if (top + 78 + 350 > this.bodyHeight) {
          this.boxStyle = {
            top: top - 350 < 0 ? 0 : top - 350 + 'px',
            // top: top - 350 + 'px',
            left: left - 46 + 'px'
          }
        } else {
          this.boxStyle = {
            top: top + 78 + 'px',
            left: left - 46 + 'px'
          }
        }
      }
    },
    out() {
      this.currentIndex = -55
    },
    next() {
      if (this.currentType < 3) {
        this.currentType = this.currentType + 1
      }
    },
    pre() {
      if (this.currentType > 1) {
        this.currentType = this.currentType - 1
      }
    }
  },
  computed: {
    calcTop() {
      return (this.currentIndex + 1) * 100
    }
  },
  created() {}
}
</script>
<style lang="less" scoped>
@import '../../assets/css/reset.css';
html {
  overflow-y: auto;
}
.con-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  // background: #f5f5f5;
  position: relative;
  min-width: 1080px;
  .title {
    background: #2e3639;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    padding: 13px 26%;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
    img {
      width: 65px;
      height: 22px;
    }
  }

  .tabs {
    display: flex;
    background: white;
    padding: 13px 26%;
    .item-list {
      font-size: 14px;
      color: #010101;
      // font-weight: bold;
      margin-right: 58px;
      position: relative;
      .item-span {
        position: relative;
      }
      img {
        width: 28px;
        height: 28px;
        margin-right: 7px;
      }
      &.active {
        color: #2cc1fb;
        font-weight: bold;
        .active-span {
          width: 18px;
          height: 3px;
          display: inline-block;
          background: #2cc1fb;
          position: absolute;
          left: calc(50% - 9px);
          bottom: -14px;
        }
      }
      &:hover {
        color: #2cc1fb;
        // font-weight: bold;
        cursor: pointer;
        // .active-span {
        //   width: 18px;
        //   height: 3px;
        //   display: inline-block;
        //   background: #2cc1fb;
        //   position: absolute;
        //   left: calc(50% - 9px);
        //   bottom: -14px;
        // }
      }
    }
  }
  .content {
    flex: 1;
    background: #2cc1fb;
    min-height: 433px;
    box-sizing: border-box;
    .wapper {
      min-width: 1080px;
      margin: 0 auto;
      padding: 0 26%;
      height: 100%;
      box-sizing: border-box;
    }
    .content-div {
      height: 100%;
    }

    .ctrl {
      min-width: 1080px;
      height: 0;
      margin: 0 auto;
      padding: 0 26%;
      box-sizing: border-box;

      > div {
        width: 100%;
        position: relative;

        z-index: 900;
      }

      .next {
        position: absolute;
        right: -100px;
        width: 22px;
        height: 22px;
        top: calc(433px / 2 - 11px);
        cursor: pointer;
      }
      .pre {
        position: absolute;
        left: -100px;
        width: 22px;
        height: 22px;
        top: calc(433px / 2 - 11px);
        cursor: pointer;
      }
    }
  }
  .flex-div {
    display: flex;
    justify-content: space-between;
    .flex-left {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      .flex-left-content {
        float: right;
        height: 100%;
        display: flex;
        flex-direction: column;
        color: white;
        // position: relative;
        padding-top: 48px;
        box-sizing: border-box;
        padding-bottom: 22px;
        &.qujiao-content {
          display: flex;
          justify-content: center;
          margin-right: 62px;
          .qujiao {
            width: 49px;
            height: 49px;
          }
        }
        .content-title {
          font-size: 20px;
        }
        .content-subtitle {
          font-size: 12px;
          margin-top: 6px;
          margin-bottom: 22px;
        }
        .code-logo {
          display: flex;
          justify-content: flex-start;
          align-items: stretch;
          flex-direction: row;
          width: 429px;
          height: 211px;
          background: #ffffff;
          box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2);
          border-radius: 10px;
          padding: 14px 20px;

          position: fixed;
          z-index: 999;

          .qrcode {
            flex-grow: 0;
            flex-shrink: 0;
            height: 100%;
            padding-right: 20px;
            border-right: solid 1px rgba(0, 0, 0, 0.1);

            text-align: center;

            > img {
              display: block;
              width: 127px;
              height: 127px;
              margin: 6px 0 0 0;
            }

            > h1 {
              margin: 20px 0 7px;

              font-size: 17px;
              font-weight: bold;
              color: #2a2a2a;
              line-height: 1;
            }

            > p {
              font-size: 12px;
              font-weight: 400;
              color: #2a2a2a;
              line-height: 1;
            }
          }

          .disc {
            flex-grow: 1;
            flex-shrink: 1;
            padding: 0 0 0 20px;

            overflow: auto;

            > h2 {
              margin: 0 0 9px;

              font-size: 12px;
              font-weight: 400;
              color: #000000;
              line-height: 1.5;

              &.zx {
                font-size: 8px;
                font-weight: 400;
                color: #2a2a2a;
              }
            }

            > ul {
              > li {
                margin-bottom: 13px;

                > h3 {
                  display: inline-block;
                  height: 13px;
                  background: #d6f3ce;
                  border-radius: 2px;
                  padding: 0 4px;
                  margin-bottom: 5px;

                  font-size: 8px;
                  font-weight: 400;
                  color: #3c9225;
                  line-height: 13px;
                }

                > p {
                  font-size: 8px;
                  font-weight: 400;
                  color: #333333;
                  line-height: 1.5;
                }
              }

              > li:nth-of-type(3n) {
                > h3 {
                  background: #d6f3ce;
                  color: #3c9225;
                }
              }

              > li:nth-of-type(3n + 1) {
                > h3 {
                  background: #fdded5;
                  color: #eb6b49;
                }
              }

              > li:nth-of-type(3n + 2) {
                > h3 {
                  background: #d5edfd;
                  color: #3a94d0;
                }
              }
            }
          }
        }
        .img-wapper {
          overflow-y: auto;
          display: flex;
          flex-wrap: wrap;

          position: relative;
        }
        img {
          margin: 8px 11px 16px 0;
          cursor: pointer;
        }
        .primary-logo {
          width: 50px;
          height: 51px;

          &.big {
            // transform: scale(1.2);
            // transform-origin: bottom center;
          }
        }
      }

      .img-wapper-div {
        margin-top: -8px;
      }
    }
    .flex-right {
      width: 50%;
      position: relative;
      height: 100%;
      img {
        position: absolute;
        bottom: 0;
        width: 420px;
      }
    }
  }
  .download {
    position: absolute;
    width: 100%;
    text-align: right;
    padding-top: 20px;
    padding-right: 8%;
    color: white;
    font-size: 18px;
    box-sizing: border-box;
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
  img {
    width: 100%;
    height: auto;
  }
  .footer {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    .copyright {
      color: #999;
    }
    .msg {
      color: #999;
      // margin-top: 10px;
      span {
        margin: 0 10px;
      }
    }
    .beian {
      // width:300px;
      display: flex;
      align-items: center;
      margin: 0 auto;
      padding: 20px 0;
      padding-top: 10px;
      a {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      img {
        width: 15px;
        height: 15px;
      }
    }
  }
}
</style>